import { render, staticRenderFns } from "./BundleRadio.vue?vue&type=template&id=3d71cac8"
import script from "./BundleRadio.vue?vue&type=script&lang=ts"
export * from "./BundleRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports